import { Dropdown, DropdownLink } from 'src/components/Inputs/Dropdown';
import { useState } from 'react';
import { isDevelopment, isProduction, isTesting } from 'src/lib/constants';

const serverOptions = [
  { label: 'Localhost', value: 'ws://localhost:5006/' },
  { label: 'Staging', value: 'wss://hello-finn-staging.herokuapp.com/' },
  { label: 'Prod', value: 'wss://hello-finn.herokuapp.com/' },
];

interface DebugServerPickerProps {
  serverSelected: (server: string) => void;
  currentServer: string;
}

// NOTE: If you want to test on localhost, start the server with
// `export PLAID_ENV = development && make start`
const DebugServerPicker: React.FC<DebugServerPickerProps> = ({
  serverSelected,
  currentServer,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = serverOptions.find((o) => o.value === currentServer);

  return (
    <>
      {!isProduction && (
        <Dropdown
          isOpen={isOpen}
          options={serverOptions.filter((o) => {
            return (
              isDevelopment || (isTesting && !o.value.includes('localhost'))
            );
          })}
          onChange={(v) => {
            setIsOpen(false);
            serverSelected(v.value);
          }}
          onEscape={() => {
            setIsOpen(false);
          }}
          value={selectedOption}
          target={
            <DropdownLink
              expanded={isOpen}
              onClick={() => {
                return setIsOpen(!isOpen);
              }}
            >
              <span>Server: </span>{' '}
              {selectedOption != null ? selectedOption.label : 'Pick one'}
            </DropdownLink>
          }
        />
      )}
    </>
  );
};

DebugServerPicker.displayName = 'DebugServerPicker';

export default DebugServerPicker;
